import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import type { NavigationGitSyncSetupSideSheet } from '@gitbook/app-navigation';
import { Dialog, DialogRoot } from '@gitbook/spine-react';

import { useNavigation, useSideSheetNavigation } from '../../../navigation';
import { useCurrentOrganization } from '../../../state';
import { GitSyncInstallationFlow } from './GitSyncInstallationFlow';

/**
 * Dialog to display the Git Sync setup flow.
 */
export function GitSyncInstallationDialog(props: { space: api.Space }): React.ReactElement | null {
    const { space } = props;

    const organization = useCurrentOrganization();
    const { navigate } = useNavigation();

    // manage gitsync setup dialog
    const { opened, close } =
        useSideSheetNavigation<NavigationGitSyncSetupSideSheet>('gitsync-setup');

    return (
        <DialogRoot isOpen={opened} onOpenChange={close}>
            <Dialog size={{ width: 896, height: 640 }}>
                <GitSyncInstallationFlow
                    space={space}
                    organization={organization}
                    onComplete={() => {
                        navigate({
                            current: {
                                sideSheet: undefined,
                            },
                        });
                    }}
                />
            </Dialog>
        </DialogRoot>
    );
}
